import { render, staticRenderFns } from "./GiftCredits.vue?vue&type=template&id=2a2a2171&lang=pug&"
import script from "./GiftCredits.vue?vue&type=script&lang=js&"
export * from "./GiftCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports